import moment from 'moment';
import { appendTimeZone, getTimeZoneAbbr } from '@s20/common/util/date';
import { getTimezones } from '@s20/common/util/l10n';
export const DispatchResourceTabNumbers = { Staff: 1, Equipment: 2, Crews: 3 };
export const DispatchJobTabNumbers = {
    Planning: 1, Ops: 2, Cancellations: 3, Events: 4,
};
export const JobAssignmentCancellationType = {
    ClientCancel: 1,
    DispatchCancel: 2,
    CallOff: 3,
    NoShow: 4,
    OfficeTransfer: 100,
};

export const DispatchResourceTabs = [
    {
        number: DispatchResourceTabNumbers.Staff,
        name: 'Staff',
        icon: 'fa-user',
    },
    {
        number: DispatchResourceTabNumbers.Equipment,
        name: 'Equipment',
        icon: 'fa-toolbox',
    },
    {
        number: DispatchResourceTabNumbers.Crews,
        name: 'Crews',
        icon: 'fa-users',
    },
];

export const DispatchJobTabs = [
    { number: DispatchJobTabNumbers.Planning, name: 'Planning' },
    /* { number: DispatchJobTabNumbers.Ops, name: 'Ops' }, */
    { number: DispatchJobTabNumbers.Cancellations, name: 'Cancellations' },
    { number: DispatchJobTabNumbers.Events, name: 'Events' },
];

export const StaffSortTypes = [
    { id: 1, label: 'Hours - Ascending' },
    { id: 2, label: 'Hours - Descending' },
    { id: 3, label: 'Name - Ascending' },
    { id: 4, label: 'Name - Descending' },
];

export const DateTimeInputFormat = (date) => new Date(date.getTime() + new Date().getTimezoneOffset() * -60 * 1000)
    .toISOString()
    .slice(0, 16);

export const formatDateTimeForTimezone = (dateTime, timezone) => {
    if (!dateTime) return '';
    return moment(dateTime)
        .tz(timezone)
        .format('YYYY-MM-DDTHH:mm');
};

export class DispatchBoardViewModel {
    activeJobTab = {
        ...DispatchJobTabs[0],
    };

    activeResourceTab = {
        ...DispatchResourceTabs[0],
    };

    allJobsCollapsed = false;

    allCancellationJobsCollapsed = false;

    crewsInterfaceOpen = false;

    dragging = false;

    equipment = [];

    isAuthenticated = false;

    jobsLoading = false;

    resourceJobs = [];

    jobsOpened = [];

    jobSearchText = '';

    cancellationJobSearchText = '';

    jobWorkflowModalOpen = false;

    lastPushUpdate = '';

    loading = true;

    loadingEquipment = false;

    opsJobs = [];

    allJobs = [];

    cancellationJobs = [];

    cancellationJobsOpened = [];

    cancellationJobsFilteredCount = 0;

    cancellationJobsMaxRows = 0;

    saving = false;

    resourcesLoading = false;

    resourceSearchText = '';

    selectedEmergencyAssignments = null;

    selectedWorkflowJob = null;

    selectedJobToCancel = null;

    selectedJobAssignmentToRemove = null;

    selectedJobDispatchLocation = null;

    selectedResourceDispatchLocation = null;

    selectedJobCancellationType = null;

    selectedJobCancellationNotes = '';

    selectedJobCancellationTime = DateTimeInputFormat(new Date());

    selectedJobAssignmentCancellationType = null;

    selectedJobAssignmentCancellationNotes = '';

    selectedJobAssignmentCancellationTime = DateTimeInputFormat(new Date());

    selectedStaffSort = StaffSortTypes[0];

    selectedWeek = null;

    selectedWeekRangeDays = [];

    showCancelAssignmentModal = false;

    staffSortDropdownOpen = false;

    staff = [];

    allStaffIds = [];

    staffLoading = false;

    crossJobsLoading = false;

    weeks = [];

    noResponse = false;

    showModal = false;

    showEmergencyConfirmModal = false;

    longTermStatuses = [];

    employeeLongTermStatuses = [];

    employeeLongTermStatusesLoading = false;

    equipmentLongTermStatuses = [];

    equipmentLongTermStatusesLoading = false;

    dailyAttendanceEvents = [];

    employeeDailyAttendanceEvents = [];

    employeeDailyAttendanceEventsLoading = false;

    areAttendanceEventsEnabled = false;

    hiddenEmployeeCount = 0;

    hiddenEquipmentCount = 0;

    onlyShowUnassigned = false;

    onlyShowAttendance = false;

    tenantSettings = {};

    onlyShowUnassignedEquipment = false;

    jobAssignmentCancellationTypeIdsThatPreventReassignment = [];

    expandedCancellationReasonRequired = false;

    companyContacts = [];

    cancelJobDataLoading = false;

    cancelContactId = null;

    draggedResource = null;

    showResourceLocations = false;

    selectedResourceLocation = null;

    isCtrlPressed = false;

    showFilterModal = false;

    modalFilterGroups = [];

    modalFilterEquip = [];

    modalFilterCerts = [];

    filters = [];

    pulsingSlotId = null;

    certificationOptions = [];

    selectedPlanningStatus = null;

    selectedCancellationStatus = null;

    cancelJobs = [];

    crossDispatchCancellationJobs = [];
}

export const FilterTypes = {
    GROUP: 'GROUP',
    EQUIPMENT_TYPE: 'EQUIPMENT_TYPE',
    CERTIFICATION: 'CERTIFICATION',
};

export const JobStatusTypes = {
    UNFILLED: 'Unfilled',
    SCHEDULED: 'Scheduled',
    NO_RESPONSE: 'No Response',
    CONFIRMED: 'Confirmed',
    CANCEL_PENDING: 'Cancel Pending',
    CANCEL_CONFIRMED: 'Cancel Confirmed',
};

export const DraggableResourceTypes = {
    Staff: 'staff',
    Equipment: 'equipment',
};

export class DispatchResourceSearchParams {
    dates = [];

    searchText = '';

    dispatchLocation = null;

    resourceLocation = null;
}

export class DispatchJobSearchParams {
    weekStartDate = '';

    weekEndDate = '';

    dispatchLocation = null;
}

export class JobAssignment {
    id = 0;

    resourceId = null;

    weekOfDate = '';

    assignmentDate = '';

    day = -1;

    assignedEmployeeId = null;

    assignedEmployeeName = '';

    assignedEquipmentId = null;

    assignedEquipmentName = '';

    equipmentEmployeeAssignmentId = null;

    equipmentEmployeeAssignmentName = '';

    confirmationStatusId = null;

    confirmationStatusName = '';

    isBulkAssignment = false;

    dates = null;
}

export class PlanningJob {
    id = null;

    name = '';

    number = '';

    address = '';

    foreman = '';

    assignments = [];

    // UI specific properties
    detailsOpen = false;
}

export const getJobAssignmentCancellationTypeIdsThatPreventReassignment = (
    jobAssignmentCancellationTypes,
) => {
    if (
        !jobAssignmentCancellationTypes
        || !jobAssignmentCancellationTypes.length
    ) {
        return [];
    }

    return jobAssignmentCancellationTypes
        .filter((jact) => jact.preventsReassignment)
        .map((jact) => jact.id);
};

export const isCancelAssignmentTreatedAsUnassigned = (
    assignment,
    jobAssignmentCancellationTypes,
) => {
    if (!assignment || !assignment.jobAssignmentCancellationTypeId) {
        return false;
    }

    if (assignment.thresholdCancel) {
        return false;
    }

    if (assignment.jobAssignmentCancellationTypeId === JobAssignmentCancellationType.DispatchCancel) {
        return true;
    }

    const jobAssignmentCancellationType = jobAssignmentCancellationTypes.find(
        (jact) => jact.id == assignment.jobAssignmentCancellationTypeId,
    );

    return (
        jobAssignmentCancellationType
        && jobAssignmentCancellationType.treatAsUnassigned
    );
};

export const isCancelAssignmentTreatedAsCancelled = (
    assignment,
    jobAssignmentCancellationTypes,
) => {
    if (!assignment || !assignment.jobAssignmentCancellationTypeId) {
        return false;
    }

    if (assignment.thresholdCancel) {
        return true;
    }

    if (assignment.jobAssignmentCancellationTypeId === JobAssignmentCancellationType.DispatchCancel) {
        return false;
    }

    const jobAssignmentCancellationType = jobAssignmentCancellationTypes.find(
        (jact) => jact.id == assignment.jobAssignmentCancellationTypeId,
    );

    return (
        jobAssignmentCancellationType
        && !jobAssignmentCancellationType.treatAsUnassigned
    );
};


export class CrossDispatchJobSearchParams {
    weekStartDate = '';
    weekEndDate = '';
    dispatchLocation = null;
}

export const ConfirmationStatus = {
    Unfilled: 1,
    Scheduled: 2,
    NoResponse: 3,
    Confirmed: 4,
    CancelPending: 5,
    ThresholdCancel: 6,
};

export const JobAssignmentCancellationTypes = {
    ClientCancel: 1,
    DispatchCancel: 2,
    CallOff: 3,
    NoShow: 4,
    OfficeTransfer: 100,
    Refusal: 101,
};

/**
 * True when `day` falls inside a long-term status row's effective range. A missing
 * endDate means the status is open-ended and covers every day from startDate onward.
 *
 * Long-term statuses are loaded for the whole selected week, so anything reasoning
 * about a single day has to check coverage instead of assuming every row applies.
 */
export const isDayWithinLongTermStatus = (day, status) => {
    const start = moment(status.startDate).startOf('day');

    if (!status.endDate) {
        return moment(day).isSameOrAfter(start, 'day');
    }

    return moment(day).isBetween(
        start,
        moment(status.endDate).endOf('day'),
        'day',
        '[]',
    );
};

const staffHasVehicleAssigned = (staffId, dayEquipmentAssignments) => dayEquipmentAssignments.some((equipSlot) =>
    equipSlot.assignedEmployee?.id === staffId &&
        equipSlot.assignment?.equipmentType?.isVehicle === true,
);

const staffIsInEligibleUserGroupForEquipment = (staff, equipmentType) => {
    const staffGroupIds = staff.groups?.map((g) => g.id) || [];

    if (!equipmentType.groups?.some((group) => staffGroupIds.includes(group.id))) {
        return false;
    }

    return true;
};

export const getEligibleStaffForEquipment = (
    equipmentBeingAssigned,
    equipmentType,
    dayAssignments,
) => {
    // Get all assigned staff for the day
    const assignedStaff = dayAssignments.staff
        .filter((s) => !!s.assignment)
        .map((s) => s.assignment);

    // If this is a vehicle, exclude staff who already have vehicles
    if (equipmentType.isVehicle) {
        return assignedStaff.filter((staff) =>
            !staffHasVehicleAssigned(staff.id, dayAssignments.equipment),
        );
    }

    // Make sure only the users in the appropriate user group for the equipment are there
    return assignedStaff.filter((staff) =>
        staffIsInEligibleUserGroupForEquipment(staff, equipmentType),
    );
};

export const getEligibleEquipmentForEquipment = (
    equipmentBeingAssigned,
    equipmentType,
    dayAssignments,
) => {
    // Get all assigned equipment for the day
    const assignedEquipment = dayAssignments.equipment
        .filter((e) => !!e.assignment)
        .map((e) => e.assignment);

    // If the equipment being assigned is a vehicle, return empty
    // (vehicles don't get assigned to other equipment)
    if (equipmentType.isVehicle) {
        return [];
    }

    // For non-vehicles (like arrow boards), find vehicles they can be assigned to
    // Return only vehicles that are assigned to the day
    return assignedEquipment.filter((equip) =>
        equip.equipmentType?.isVehicle === true,
    );
};

export const selectedDayHasOverride = (selectedJob) => {
    const { job, day: dayIndex } = selectedJob;

    if (!selectedJob || !job?.overrides || job?.overrides.length === 0) {
        return false;
    }

    return job.overrides.find((override) => moment(override.overrideDate, moment.ISO_8601).day() === dayIndex);
};

export const getJobTimeZone = (selectedDay) => {
    if (selectedDay != null) {
        const override = selectedDayHasOverride(selectedDay);
        const jobWinId = override?.timeZone ? override.timeZone : selectedDay?.job.timeZone;
        const { ianaTimezones } = getTimezones();
        const jobtimeZone = ianaTimezones?.find((tz) => tz.id === jobWinId || tz.value === jobWinId)?.value;
        return jobtimeZone;
    }
};

export const getCorrectTime = (selectedDay, dateTime) => {
    if (selectedDay != null) {
        const jobtimeZone = getJobTimeZone(selectedDay);
        return formatDateTimeForTimezone(dateTime, jobtimeZone);
    }
};

export const getJobStartTime = (selectedDay) => {
    if (!selectedDay) {
        return '';
    }
    const override = selectedDayHasOverride(selectedDay);
    const timeString = override?.startTime ? moment(override.startTime, 'HH:mm').format('hh:mm A') : selectedDay.job.startTime;
    const timeZone = override?.timeZone ? override.timeZone : selectedDay.job.timeZone;
    const offSet = override?.startTimeOffset ? override.startTimeOffset : selectedDay.job.startTimeOffset;
    return appendTimeZone(timeString, offSet, timeZone);
};

export const getTzAbbreviation = (selectedDayJobToRemove) => {
    if (!selectedDayJobToRemove) return '';
    const job = selectedDayJobToRemove?.job;
    if (!job) return '';
    const override = selectedDayHasOverride(selectedDayJobToRemove);
    const timeZone = override?.timeZone ? override.timeZone : selectedDayJobToRemove.job.timeZone;
    const offset = override?.startTimeOffset ? override.startTimeOffset : selectedDayJobToRemove.job.startTimeOffset;
    return getTimeZoneAbbr(offset, timeZone);
};

export const doesJobHaveCrewLead = (job, day) => {
    const result = !!job.assignments[day].staff.filter((x) => !!x.isCrewLead)
        .length;
    return result;
};

/**
 * Drag End Handler
 *
 * This is very verbose, and supports all of the drop scenarios as the drop context wraps the entire dispatch
 * board.  When dropping an item, we use the passed in droppableId/draggableIds to lookup the corresponding data for manipulation,
 * as beautiful DnD doesn't really support passing around data objects/arrays.
 *
 * @param {any} result
 */
// Helper: build one AssignmentItemDTO
export const makeAssignmentItem = ({
    jobId,
    resourceId,
    weekOfDate,
    assignmentDate,
    day,
    employeeId,
    equipmentId,
    assignedEmployeeId,
    assignedEquipmentId,
    equipmentEmployeeAssignmentId,
    equipmentAssignedEquipmentId,
    isRentalPickup,
    ...rest
}) => ({
    jobId,
    resourceId,
    weekOfDate,
    assignmentDate,
    day,
    confirmationStatusId: 2,
    assignedEmployeeId: employeeId ?? assignedEmployeeId ?? null,
    assignedEquipmentId: equipmentId ?? assignedEquipmentId ?? null,
    equipmentEmployeeAssignmentId: equipmentEmployeeAssignmentId ?? null,
    equipmentAssignedEquipmentId: equipmentAssignedEquipmentId ?? null,
    isRentalPickup: Boolean(isRentalPickup),
    ...rest,
});

// Equipment that rides along with a dragged resource, two levels deep: an employee brings their
// assigned equipment and what is mounted on it; a piece of equipment brings what is mounted on it.
// Each entry carries the card link to write on its assignment.
export const getLinkedEquipmentCandidates = (resource, resourceType) => {
    if (resourceType === DraggableResourceTypes.Staff) {
        return (resource.assignedEquipment ?? []).flatMap((eq) => [
            { ...eq, equipmentEmployeeAssignmentId: resource.id },
            ...(eq.mountedEquipment ?? []).map((m) => ({ ...m, equipmentAssignedEquipmentId: eq.id })),
        ]);
    }

    return (resource.mountedEquipment ?? []).map((m) => ({ ...m, equipmentAssignedEquipmentId: resource.id }));
};

const isStaffAssigned = (job, searchTerm) => {
    // searchTerm: "doe"
    const r = new RegExp(searchTerm, 'i');

    const nameSet = new Set();

    const entries = Object.entries(job.assignments);
    for (const entry of entries) {
        const [_, a] = entry;

        for (const s of a.staff) {
            // s.assignment.name: "Doe, John"
            if (s.assignment) {
                nameSet.add(s.assignment.name);
            }
        }
    }

    const nameArray = Array.from(nameSet);
    const isFound = nameArray.find((n) => r.test(n));

    return isFound;
};

// A project job arrives either as one entry per job or as one combined entry listing the project's
// jobs in jobIdsInGroup, so two entries are the same job when any of their ids overlap.
const isSameJob = (a, b) => {
    const aIds = [a.id, ...(a.jobIdsInGroup ?? [])].map((id) => parseFloat(id));
    const bIds = [b.id, ...(b.jobIdsInGroup ?? [])].map((id) => parseFloat(id));

    return aIds.some((id) => bIds.some((other) => id === other));
};

const hasAssignedResource = (slots, resourceIds) => Object.values(slots ?? {})
    .some((slot) => slot.assignment && resourceIds.includes(slot.assignment.id));

// True when the job puts one of the board's staff or equipment on a day of the shown week.
const isJobForBoardResources = (job, staffIds, equipmentIds, weekDays) => {
    if (job.isDeleted) {
        return false;
    }

    return Object.values(job.assignments ?? {}).some((assignment) => {
        if (assignment.isCancelled) {
            return false;
        }

        const isInShownWeek = weekDays.some((d) => moment(d.date).isSame(moment(assignment.date), 'day'));
        if (!isInShownWeek) {
            return false;
        }

        return hasAssignedResource(assignment.staff, staffIds)
            || hasAssignedResource(assignment.equipment, equipmentIds);
    });
};

// Applies pushed job updates to the jobs the board's staff and equipment are on (resourceJobs).
// The board loads those only once, so besides replacing the entries it already has, a pushed job
// joins them when it puts one of the board's employees or equipment on a day of the shown week;
// that is how an assignment made by another office reaches the Staff and Equipment panels.
export const mergePushedResourceJobs = (resourceJobs, pushedJobs, staffIds, equipmentIds, weekDays) => {
    const merged = [];

    resourceJobs.forEach((rj) => {
        const job = pushedJobs.find((pj) => isSameJob(pj, rj)) ?? rj;
        if (!job.isDeleted && !merged.includes(job)) {
            merged.push(job);
        }
    });

    const added = pushedJobs.filter((pj) => !resourceJobs.some((rj) => isSameJob(pj, rj))
        && isJobForBoardResources(pj, staffIds, equipmentIds, weekDays));

    return [...merged, ...added];
};

// Accept the job if the jobSearchText is found in variety of places.
export const doesJobPassSearchText = (job, jobSearchText) => {
    const jst = (jobSearchText ?? '').trim();

    // No job search text - accept the job.
    if (jst === '') return true;

    // Build a case-insensitive matcher from the user's text. Escape it first so
    // characters that are common in addresses but special in a regex (e.g. '(', ')',
    // '.') are matched literally instead of throwing or matching unexpectedly.
    const escaped = jst.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const r = new RegExp(escaped, 'i');

    // Search the following:
    //  Work Order Number
    //  Contract Number + Sequence ('number' property: 444ABC-3)
    //  Contract Company Name
    //  Foreman (first/last name)
    //  Job Description (contained in 'name')
    //  Subcontractor Company (contained in 'name')
    //  Assigned employee name (in assignments)
    //  Job address, meeting address, and city
    const isFound = r.test(job.name)
            || r.test(job.foremanName)
            || r.test(job.number)
            || r.test(job.workOrderNumber)
            || r.test(job.contractCompanyName)
            || r.test(job.jobAddress ?? '')
            || r.test(job.meetingAddress ?? '')
            || r.test(job.city ?? '')
            || isStaffAssigned(job, jst);

    return isFound;
};

export const doesJobPassPlanningFilter = (job, day, selectedPlanningStatus) => {
    if (!selectedPlanningStatus) {
        return true;
    }

    const slots = [
        ...job.assignments[day].staff,
        ...job.assignments[day].equipment,
    ];

    return slots.some(({ assignment }) => {
        switch (selectedPlanningStatus) {
        case JobStatusTypes.UNFILLED:
            return !assignment;
        case JobStatusTypes.SCHEDULED:
            return assignment?.confirmationStatusId === ConfirmationStatus.Scheduled;
        case JobStatusTypes.NO_RESPONSE:
            return assignment?.confirmationStatusId === ConfirmationStatus.NoResponse;
        case JobStatusTypes.CONFIRMED:
            return assignment?.confirmationStatusId === ConfirmationStatus.Confirmed;
        default:
            return false;
        }
    });
};

export const getPlanningBoard = (planningJobs, selectedWeekRangeDays) => {
    const accumulator = {
        filled: 0,
        unfilled: 0,
        noResponse: 0,
        confirmed: 0,
        cancelled: 0,
        regenerable: 0,
    };

    const days = selectedWeekRangeDays.map((wrd) => wrd.getDay());
    const staff = planningJobs.reduce(
        (acc, job) => {
            const unfilled = acc.unfilled
                + days.reduce((acc, day) => (
                    acc
                    + job.assignments[day].staff.length
                    - job.assignments[day].staff.filter(
                        (g) => !!g.assignment,
                    ).length
                ), 0);

            const filled = acc.filled
                + days.reduce((acc, day) => (
                    acc
                    + job.assignments[day].staff.filter(
                        (g) => !!g.assignment
                            && g.assignment.confirmationStatusId
                            === ConfirmationStatus.Scheduled,
                    ).length
                ), 0);

            // Auto-assign only replaces assignments it created itself and that nobody has been
            // notified about, so a manually-assigned scheduled slot is not recalculable.
            const regenerable = acc.regenerable
                + days.reduce((acc, day) => (
                    acc
                    + job.assignments[day].staff.filter(
                        (g) => !!g.assignment
                            && g.assignment.isAutoAssignment
                            && g.assignment.confirmationStatusId
                            === ConfirmationStatus.Scheduled,
                    ).length
                ), 0);

            const noResponse = acc.noResponse
                + days.reduce((acc, day) => (
                    acc
                    + job.assignments[day].staff.filter(
                        (g) => !!g.assignment
                            && g.assignment.confirmationStatusId
                            === ConfirmationStatus.NoResponse,
                    ).length
                ), 0);

            const confirmed = acc.confirmed
                + days.reduce((acc, day) => (
                    acc
                    + job.assignments[day].staff.filter(
                        (g) => !!g.assignment
                            && g.assignment.confirmationStatusId
                            === ConfirmationStatus.Confirmed,
                    ).length
                ), 0);
            return {
                unfilled,
                filled,
                noResponse,
                confirmed,
                regenerable,
            };
        },
        { ...accumulator },
    );

    const eq = planningJobs.reduce(
        (acc, job) => {
            const unfilled = acc.unfilled
                    + days.reduce((acc, day) => (
                        acc
                        + (job.assignments[day].equipment.length
                            - job.assignments[day].equipment.filter(
                                (g) => !!g.assignment,
                            ).length)
                    ), 0);
            const filled = acc.filled
                    + days.reduce((acc, day) => (
                        acc
                        + job.assignments[day].equipment.filter(
                            (g) => (g.assignment ?? {})
                                .confirmationStatusId
                                === ConfirmationStatus.Scheduled,
                        ).length
                    ), 0);
            // Mirrors the staff counter: only auto-created, un-notified assignments are recalculable.
            const regenerable = acc.regenerable
                    + days.reduce((acc, day) => (
                        acc
                        + job.assignments[day].equipment.filter(
                            (g) => (g.assignment ?? {}).isAutoAssignment
                                && (g.assignment ?? {})
                                    .confirmationStatusId
                                    === ConfirmationStatus.Scheduled,
                        ).length
                    ), 0);
            const noResponse = acc.noResponse
                    + days.reduce((acc, day) => (
                        acc
                        + job.assignments[day].equipment.filter(
                            (g) => (g.assignment ?? {})
                                .confirmationStatusId
                                === ConfirmationStatus.NoResponse,
                        ).length
                    ), 0);
            const confirmed = acc.confirmed
                    + days.reduce((acc, day) => (
                        acc
                        + job.assignments[day].equipment.filter(
                            (g) => (g.assignment ?? {})
                                .confirmationStatusId
                                === ConfirmationStatus.Confirmed,
                        ).length
                    ), 0);
            return {
                unfilled,
                filled,
                noResponse,
                confirmed,
                regenerable,
            };
        },
        { ...accumulator },
    );

    return {
        staff: {
            unfilled: staff.unfilled,
            scheduled: staff.filled,
            noResponse: staff.noResponse,
            confirmed: staff.confirmed,
            regenerable: staff.regenerable,
        },
        equipment: {
            unfilled: eq.unfilled,
            scheduled: eq.filled,
            noResponse: eq.noResponse,
            confirmed: eq.confirmed,
            regenerable: eq.regenerable,
        },
    };
};